export const DIALOG_ELEMENT_NAME = 'pimster-dialog';
export const IFRAME_ELEMENT_ID = 'pimster-iframe';
export const DIALOG_DEFAULT_Z_INDEX = 9999;
